import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { DropDownItemComponent } from '../../../shared/component/drop-down-item/drop-down-item.component';
import { EMPLOYEE_SORT, EmployeeDTO } from '../../../user/employee/dto/EmployeeDTO';
import { EmployeeRoleDisplayPipe } from "../../../../util/pipes/employee-role-display.pipe";
import { Subject } from 'rxjs';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ThreeDotsMenuComponent } from '../../../shared/component/three-dots-menu/three-dots-menu.component';
import { AuthService } from "../../../auth/service/auth.service";
import { SortDirective } from '../../../../util/directives/sort/sort.directive';
import { EmployeeRole } from '../../../user/employee/dto/role-type';
import { SelectorComponent } from '../../../shared/component/inputs/selector/selector.component';

@Component({
  selector: 'app-team-table',
  templateUrl: './team-table.component.html',
  styleUrls: ['./team-table.component.scss'],
  imports: [
    MatMenu,
    DropDownItemComponent,
    MatMenuTrigger,
    EmployeeRoleDisplayPipe,
    ThreeDotsMenuComponent,
    SortDirective,
    SelectorComponent,
  ],
})
export class TeamTableComponent implements OnDestroy, OnInit {
  private _destroyStream: Subject<void> = new Subject<void>();
  private authService = inject(AuthService);

  readonly employeeSort = EMPLOYEE_SORT;

  @Input() employees: EmployeeDTO[] = [];
  @Input() isAdmin = false;
  @Input() modalMode = false;

  @Output() deleteUser = new EventEmitter<EmployeeDTO>();
  @Output() resendInvite = new EventEmitter<EmployeeDTO>();
  @Output() updateRole =
    new EventEmitter<{employee: EmployeeDTO, role: EmployeeRole}>();


  currentUserEmail: string;
  selectedEmployee: EmployeeDTO;

  availableRoles: EmployeeRoleOption[] = [
    { role: EmployeeRole.ADMIN, displayRole: 'Admin' },
    { role: EmployeeRole.VIEWER, displayRole: 'User' },
  ];

  roleOptionsMap = new Map<EmployeeRole, EmployeeRoleOption>([
    [EmployeeRole.ADMIN, { role: EmployeeRole.ADMIN, displayRole: 'Admin' }],
    [EmployeeRole.VIEWER, { role: EmployeeRole.VIEWER, displayRole: 'User' }],
  ]);

  ngOnInit(): void {
    this.currentUserEmail = this.authService.userInfoValue.mail;
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  onDelete(employee: EmployeeDTO): void {
    this.deleteUser.emit(employee);
  }

  onResendInvite(employee: EmployeeDTO): void {
    this.resendInvite.emit(employee);
  }

  sendEmail(email: string): void {
    window.location.href = `mailto:${email}`;
  }

  chosenUserEmitter(employee: EmployeeDTO): void {
    this.selectedEmployee = employee;
  }

  updateEmployeeRole(employee: EmployeeDTO, newRole: EmployeeRole): void {
    if (employee.role === newRole) {
      return;
    }
    this.updateRole.emit({ employee, role: newRole });
  }
}

export interface EmployeeRoleOption {
  role: EmployeeRole;
  displayRole: string;
}
